import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

type LocaleWithId = {
  idLocale: number;
};

// Базовый тип для общих полей локали
type LocaleCommonFields = {
  idCountry: number;
  formatDate: string;
  formatTime: string;
  formatNumber: string;
  formatAddress: string;
  formatTelephone: string;
  metric: boolean;
  collation: string;
  firstWeekDay: number;
  timezone: string;
};

// Типы для WebSocket сообщений компонента locales
type LocaleListMessage = WebSocketMessageWithFields<'language-locale-list' | 'language-country-list' | 'language-switcher-data', {
  locales: unknown[];
  localeConfiguration?: unknown;
}>;
type LocaleConfigurationMessage = WebSocketMessageWithFields<'locale-configuration', {
  localeConfiguration: unknown;
}>;
type LocaleCreateMessage = WebSocketMessageWithFields<'language-locale-create' | 'language-locale-create-success', LocaleWithId & {
  idLanguage: number;
} & LocaleCommonFields>;
type LocaleUpdateMessage = WebSocketMessageWithFields<'language-locale-update' | 'language-locale-update-success', LocaleWithId & LocaleCommonFields>;
type LocaleDeleteMessage = WebSocketMessageWithFields<'language-locale-delete' | 'language-locale-delete-success', LocaleWithId>;
type LocaleLockMessage = WebSocketMessageWithFields<'language-locale-lock' | 'language-locale-lock-success', LocaleWithId>;
type LocaleUnlockMessage = WebSocketMessageWithFields<'language-locale-unlock' | 'language-locale-unlock-success', LocaleWithId>;

// Объединенный тип для всех сообщений
type LocalesWebSocketMessage = 
  | LocaleListMessage 
  | LocaleConfigurationMessage 
  | LocaleCreateMessage 
  | LocaleUpdateMessage 
  | LocaleDeleteMessage 
  | LocaleLockMessage 
  | LocaleUnlockMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'dataLocales',
},
  __name: 'locales',
  setup(__props) {

const store = useStore<RootState>();



// Базовый тип для сообщений с ID локали
const handleWebSocketMessage = (data: LocalesWebSocketMessage): void => {
  if (!data?.signal) return;
  
  switch (data.signal) {
    case 'language-locale-list':
    case 'language-country-list':
    case 'language-switcher-data':
      store.dispatch('locales/wsSetLocales', { locales: data.locales });
      if (data.localeConfiguration) {
        store.dispatch('locales/wsSetLocaleConfiguration', data.localeConfiguration);
      }
      break;
    case 'locale-configuration':
      if (data.localeConfiguration) {
        store.dispatch('locales/wsSetLocaleConfiguration', data.localeConfiguration);
      }
      break;
    case 'language-locale-create':
    case 'language-locale-create-success':
      store.dispatch('locales/wsLocaleCreate', data);
      break;
    case 'language-locale-update':
    case 'language-locale-update-success':
      store.dispatch('locales/wsLocaleUpdate', data);
      break;
    case 'language-locale-delete':
    case 'language-locale-delete-success':
      store.dispatch('locales/wsLocaleDelete', { idLocale: data.idLocale });
      break;
    case 'language-locale-lock':
    case 'language-locale-lock-success':
      store.dispatch('locales/wsLocaleLock', { idLocale: data.idLocale });
      break;

    case 'language-locale-unlock':
    case 'language-locale-unlock-success':
      store.dispatch('locales/wsLocaleUnlock', { idLocale: data.idLocale });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})